/**
 * Verifica se o dado informado é null ou undefined.
 * @public
 * @function
 * @param {any} data Dado de qualquer tipo.
 * @returns {boolean} Se o dado é null ou undefined.
*/
const IsNull = (data) => {
    //  É mais fácil "undefined" deixar de existir do que "null != undefined".
    //  A segunda verificação é para previnir problemas.
    return data == null || data == undefined;
};

/**
 * Verifica se o dado informado é do tipo {@link String}.
 * @public
 * @function
 * @param {any} data Dado de qualquer tipo.
 * @returns {boolean} Se o dado é do tipo {@link String}.
*/
const IsString = (data) => {

    //  Fatos:
    //  var a = "teste";
    //  var b = new String("teste");
    //  a === b             -> false
    //  a == b              -> true
    //  typeof a            -> "string"
    //  typeof b            -> "object"
    //  a instanceof String -> false
    //  b instanceof String -> true
    //  Object.prototype.toString.call(a) -> "[object String]"
    //  Object.prototype.toString.call(b) -> "[object String]"
    //  Object.getPrototypeOf(a).constructor.name -> "String"
    //  Object.getPrototypeOf(b).constructor.name -> "String"

    return (
        typeof data === "string"
        || data instanceof String
    );
};

/**
 * Verifica se o dado informado é do tipo 'number'.
 * @public
 * @function
 * @param {any} data Dado de qualquer tipo.
 * @returns {boolean} Se o dado é do tipo 'number'.
*/
const IsNumber = (data) => {

    //  Fatos:
    //  var a = 0;
    //  var b = new Number();
    //  a === b             -> false
    //  a == b              -> true
    //  typeof a            -> "number"
    //  typeof b            -> "object"
    //  a instanceof Number -> false
    //  b instanceof Number -> true
    //  Object.prototype.toString.call(a) -> "[object Number]"
    //  Object.prototype.toString.call(b) -> "[object Number]"

    return (
        typeof data === "number"
        || data instanceof Number
    );
};

/**
 * Verifica se o dado informado é do tipo {@link Boolean}.
 * @public
 * @function
 * @param {any} data Dado de qualquer tipo.
 * @returns {boolean} Se o dado é do tipo {@link Boolean}.
*/
const IsBoolean = (data) => {

    //  Fatos:
    //  var a = false;
    //  var b = new Boolean();
    //  a === b                     -> false
    //  a == b                      -> true
    //  a.valueOf() === b.valueOf() -> true
    //  typeof a                    -> "boolean"
    //  typeof b                    -> "object"
    //  a instanceof Boolean        -> false
    //  b instanceof Boolean        -> true
    //  Object.prototype.toString.call(a) -> "[object Boolean]"
    //  Object.prototype.toString.call(b) -> "[object Boolean]"

    return (
        typeof data === "boolean"
        || data instanceof Boolean
    )
};

/**
 * Tenta converter o dado informado para o tipo {@link boolean}.
 * @public
 * @function
 * @param {any} data Dado que será convertido.
 * @returns {boolean|null} O dado convertido para um valor {@link boolean} ou null.
 */
const ToBoolean = (data) => {

    if ( IsBoolean(data) ) return data.valueOf();

    if ( IsString(data) ) {

        data = data.toLowerCase();

        switch (data) {
            case "false":
            case "0":
            case "f":
            case "n":
            case "no":
            case "nao":
            case "não":
                return false;
            
            case "true":
            case "1":
            case "t":
            case "y":
            case "yes":
            case "s":
            case "sim":
                return true;
        }
    }

    if ( IsNumber(data) ) {

        switch (data) {
            case 0: return false;
            case 1: return true;
        }
    }

    return null;
};

/**
 * Verifica se o dado informado é do tipo 'Date'.
 * @public
 * @function
 * @param {any} date 
 * @returns {boolean} Se o parâmetro informado é do tipo 'Date'.
*/
const IsDate = (date) => {
    return typeof date === "object"
        && (
            date instanceof Date
            || Object.prototype.toString.call(date) === "[object Date]"
        )
};

/**
 * Verifica se o dado informado é do tipo Function.
 * @public
 * @function
 * @param {any} data Dado de qualquer tipo.
 * @returns {boolean} Se o dado é do tipo Function.
*/
const IsFunction = (data) => {
    return (
        !IsNull(data)
        && typeof data === "function"
        && data instanceof Function
    )
};

/**
 * Verifica se o dado informado é do tipo {@link Event}.
 * @public
 * @function
 * @param {any} data 
 * @returns Se o dado é do tipo {@link Event}.
 */
const IsEvent = (data) => {
    return (
        typeof data === "object"
        && data instanceof Event
    );
};

export default {
    IsNull,
    IsString,
    IsNumber,
    IsBoolean,
    ToBoolean,
    IsDate,
    IsFunction,
    IsEvent,
};